export const aryFilter = (ary, keyword, cfgObj) => {
  /**
   * 对数组进行模糊筛选查找，返回一个新的数组
   * ary {Array} 字符串或对象数组
   * keyword {String} 关键词
   * cfgObj = { //可选
   *     maxLen: 512, //字符串长度不小于该值不校验
   *     attrAry: ['attrA', 'attrB'], //需要校验的属性数组，默认无，全部校验
   *     attrAryDark: false, //黑名单，即校验上述数组不包含的属性
   *     attrFunc: {
   *         attrA: (attrVal, reg, keyword) => {}, //返回 truthy 即新增
   *     },
   *     regAttr: false, //是否校验对象属性
   * }
   */

  if (!keyword) return ary;
  const reg = regExpQuote(keyword, 1, "i");
  cfgObj = {
    maxLen: 512, //字符串长度不小于该值不校验
    regAttr: true, //是否校验对象属性
    attrFunc: {},
    ...(cfgObj || {}),
  };

  const newAry = [];
  ary.map((tar) => {
    if (typeof tar === "object") {
      for (let va in tar) {
        if (cfgObj.attrAry) {
          if (cfgObj.attrAryDark) {
            if (cfgObj.attrAry.indexOf(va) >= 0) continue;
          } else {
            if (cfgObj.attrAry.indexOf(va) < 0) continue;
          }
        }

        if (cfgObj.attrFunc[va]) {
          if (cfgObj.attrFunc[va](tar[va], reg, keyword))
            return newAry.push(tar);
        } else {
          if (cfgObj.regAttr) {
            if (va.length < cfgObj.maxLen && reg.test(va))
              return newAry.push(tar);
          }

          if (tar[va] && tar[va].length < cfgObj.maxLen && reg.test(tar[va]))
            return newAry.push(tar);
        }
      }
    } else if (tar.length < cfgObj.maxLen && reg.test(tar)) {
      newAry.push(tar);
    }
  });

  return newAry;

  function regExpQuote(str, retReg, regArg) {
    //剔除正则表达式中的引用值
    const newStr = str.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    if (!retReg) return newStr;
    return new RegExp(newStr, regArg);
  }
};
